module.exports = __webpack_public_path__ + "img/shiyanshi.f7c49f65.png";